export const SELECT_PATIENT_INFO_MODE = 'SELECT_PATIENT_INFO_MODE';
export type SELECT_PATIENT_INFO_MODE = typeof SELECT_PATIENT_INFO_MODE;

export const PATIENT_CREATION_SUCCESSFUL = 'PATIENT_CREATION_SUCCESSFUL';
export type PATIENT_CREATION_SUCCESSFUL = typeof PATIENT_CREATION_SUCCESSFUL;

export const STAGE_PATIENT_DATA = 'STAGE_PATIENT_DATA';
export type STAGE_PATIENT_DATA = typeof STAGE_PATIENT_DATA;

export const TOGGLE_PATIENT_INFO_EDIT_POPUP = 'TOGGLE_PATIENT_INFO_EDIT_POPUP';
export type TOGGLE_PATIENT_INFO_EDIT_POPUP = typeof TOGGLE_PATIENT_INFO_EDIT_POPUP;

export const SAVE_PATIENT_EMAILS = 'SAVE_PATIENT_EMAILS';
export type SAVE_PATIENT_EMAILS = typeof SAVE_PATIENT_EMAILS;

export const SAVE_PATIENT_PHONES = 'SAVE_PATIENT_PHONES';
export type SAVE_PATIENT_PHONES = typeof SAVE_PATIENT_PHONES;

export const SAVE_PATIENT_ADDRESSES = 'SAVE_PATIENT_ADDRESSES';
export type SAVE_PATIENT_ADDRESSES = typeof SAVE_PATIENT_ADDRESSES;

export const SAVE_PATIENT_DEMOGRAPHICS = 'SAVE_PATIENT_DEMOGRAPHICS';
export type SAVE_PATIENT_DEMOGRAPHICS = typeof SAVE_PATIENT_DEMOGRAPHICS;

export const SAVE_PATIENT_PREFERRED_PHARMACY = 'SAVE_PATIENT_PREFERRED_PHARMACY';
export type SAVE_PATIENT_PREFERRED_PHARMACY = typeof SAVE_PATIENT_PREFERRED_PHARMACY;


// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/constants.ts